import React from 'react'
import Loader from 'react-loader-spinner'
import './index.css'

const LoadingIndicator = () => {
  return (
    <div className="loader-container">
      <div className="loader-container-inner">
        <div className="text-center">
          <Loader type="Circles" color="#00BFFF" height={80} width={80}/>
        </div>
      </div>
    </div>
  )
}

export default LoadingIndicator